import React from "react"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { persistedStore, store } from "./store"
import { PersistGate } from "redux-persist/integration/react"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import ReactDOM from "react-dom/client"
import PresenceProvider from "./providers/PresenceProvider"
import DirectContactsProvider from "./providers/DirectContactsProvider"
import ScrollToTop from "./components/Common/ScrollToTop"

window.addEventListener("unhandledrejection", event => {
  if (event.reason?.response?.status >= 500) {
    event.preventDefault()
  }
})

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistedStore}>
      <BrowserRouter>
        <ScrollToTop />
        <PresenceProvider>
          <DirectContactsProvider>
            <App />
            <ToastContainer
              position="bottom-center"
              theme="colored"
              style={{ zIndex: 20100 }}
            />
          </DirectContactsProvider>
        </PresenceProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
)

serviceWorker.unregister()
